import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mui/material/node/Box/index.js");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-no-ssr.js");
import(/* webpackMode: "eager" */ "/vercel/path0/src/layouts/main/layout.js");
import(/* webpackMode: "eager" */ "/vercel/path0/src/sections/home/view/home-view.jsx")